import React, { useState } from 'react';
import { getCustomerDetailsAPI } from '../../../services/api';
import Navbar from '../../../components/Navbar';
import Notify from '../../../components/notify';
import Footer from "../../../components/Footer";
import TableHeader from './table-header';
import TableBody from './table-body';

const Variants = () => {
	const [variants, setVariants] = useState([]);

	const [openNotify, setOpenNotify] = useState(false);
	const [errors, setErrors] = useState({});

	const handleLookup = async (customerId) => {
		try {
			const customerInfo = await getCustomerDetailsAPI(customerId);
			const orderedVariants = customerInfo.variant.sort((a, b) => a.variant_id - b.variant_id);
			setVariants(orderedVariants);
		} catch (err) {
			setVariants([]);
			setErrors(err);
			setOpenNotify(true);
		}
	};

	return (
		<>
			<Navbar />
			<div className="min-h-full flex justify-center items-center campain-table-container container">
				<div className="table-wrapper w-full">
					<div className="campain-title">
						<h2 className="text-center mt-3">Variants</h2>
						<TableHeader handleLookup={handleLookup} />
						<TableBody variants={variants || []} />
					</div>
				</div>
			</div>
			<Footer />
			<Notify
				open={openNotify}
				onClose={() => setOpenNotify(false)}
				errors={errors}
			/>
		</>
	);
};

export default Variants;
